import { render, staticRenderFns } from "./doctorManage.vue?vue&type=template&id=38b62656&scoped=true"
import script from "./doctorManage.vue?vue&type=script&lang=js"
export * from "./doctorManage.vue?vue&type=script&lang=js"
import style0 from "./doctorManage.vue?vue&type=style&index=0&id=38b62656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b62656",
  null
  
)

export default component.exports